import { render, staticRenderFns } from "./ServerSelect.vue?vue&type=template&id=0054885f&scoped=true"
import script from "./ServerSelect.vue?vue&type=script&lang=js"
export * from "./ServerSelect.vue?vue&type=script&lang=js"
import style0 from "./ServerSelect.vue?vue&type=style&index=0&id=0054885f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0054885f",
  null
  
)

export default component.exports